import React from 'react';

/**
 * Animated success checkmark for confirmation screens.
 * Draws the circle first, then the checkmark with a slight delay.
 */
export default function SuccessCheckmark() {
  return (
    <div className="flex justify-center mb-2 cp_status-icon text-[var(--cp_checkout-confirmation-mark-color)]">
      <svg
        className="[width:var(--cp_checkout-confirmation-mark-size)] [height:var(--cp_checkout-confirmation-mark-size)]"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="28"
          cy="28"
          r="27"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          className="cp_success-checkmark-circle"
          style={{
            strokeDasharray: 170,
            strokeDashoffset: 170,
            animation: 'cp-draw-circle 0.6s ease-out 0.3s forwards',
          }}
        />
        <path
          d="m19 28 6 6 12-12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          className="cp_success-checkmark-check"
          style={{
            strokeDasharray: 30,
            strokeDashoffset: 30,
            animation: 'cp-draw-check 0.3s ease-out 0.7s forwards',
          }}
        />
      </svg>
    </div>
  );
}

export function InlineSuccessCheckmark({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="28"
        cy="28"
        r="26"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
        style={{
          strokeDasharray: 170,
          strokeDashoffset: 170,
          animation: 'cp-draw-circle 0.5s ease-out forwards',
        }}
      />
      <path
        d="m19 28 6 6 12-12"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        style={{
          strokeDasharray: 30,
          strokeDashoffset: 30,
          animation: 'cp-draw-check 0.3s ease-out 0.4s forwards',
        }}
      />
    </svg>
  );
}
